export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  allFeedback: 'all-feedback',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  allFeedback: {
    view: 'view',
    statistics: 'statistics',
  },
};
